module.exports = __webpack_public_path__ + "static/media/FrancoisGuerrier.ec135589.jpg";